module.exports = "<div *ngIf=\"(item|meta); let meta\" class=\"container-fluid marquee-document\" [lazyBgSrc]=\"meta.images\">\n    <p><span class=\"title pointer\" [class.pointer-right]=\"meta.sub_head\" >{{meta.title}}</span> <span *ngIf=\"meta.sub_head\" class=\"subtitle\">{{meta.sub_head}}</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/marquee-document/marquee-document.template.html
// module id = 777
// module chunks = 2